import React from 'react'
import { Form, Input, InputNumber, Button } from 'antd'
import { PlusOutlined, CloseCircleOutlined } from '@ant-design/icons'

interface SubItemsProps {
  field: any
  innerField: any
  form: any
}

const SubItems: React.FC<SubItemsProps> = ({ field, innerField, form }) => {
  // 监听当前评分项的赋分值
  const scoreRangeMax = Form.useWatch(['nodeResults', field.name, 'items', innerField.name, 'scoreRangeMax'], form)
  return (
    <Form.List name={[innerField.name, 'subItems']}>
      {(subInnerfields, { add: addSubInner, remove: removeSubInner }) => (
        <>
          {subInnerfields.map((subInnerField: any, subInnerIndex: number) => (
            <div className="moc-form-secondary-item" key={subInnerField.key}>
              <span style={{ color: '#d9d9d9', border: '1px solid #d9d9d9', height: 32, padding: '4px 15px' }}>评分细则</span>
              <Form.Item style={{ flex: 1, marginBottom: 0 }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Form.Item
                    rules={[{ required: true, message: '请输入评分范围' }]}
                    style={{ marginLeft: 10 }}
                    name={[subInnerField.name, 'scoreRangeMin']}
                  >
                    <InputNumber min={0} max={scoreRangeMax || 20} />
                  </Form.Item>
                  <span style={{ paddingTop: 4 }}>-</span>
                  <Form.Item
                    rules={[{ required: true, message: '请输入评分范围' }]}
                    name={[subInnerField.name, 'scoreRangeMax']}
                  >
                    <InputNumber min={0} max={scoreRangeMax || 20} />
                  </Form.Item>
                  <Form.Item
                    style={{ flex: '1' }}
                    name={[subInnerField.name, 'description']}
                    rules={[{ required: true, message: '请输入评分细则' }]}
                  >
                    <Input maxLength={500} placeholder="请选择分数段，并详细描述在怎样的情况下，在该评分项下分数位于该分数段" />
                  </Form.Item>
                </div>
              </Form.Item>
              <Button
                icon={<CloseCircleOutlined />}
                type="link"
                onClick={() => removeSubInner(subInnerField.name)}
                style={{ flexShrink: 0, width: 49 }}
              />
            </div>
          ))}
          <div style={{ margin: '0 49px 20px 80px' }}>
            <Button
              style={{ borderColor: '#1890ff', color: '#1890ff', width: '100%' }}
              onClick={() => addSubInner()}
            >
              新建子项
            </Button>
          </div>
        </>
      )}
    </Form.List>
  )
}

export default SubItems
